export default (decoded: any) => decoded?.exp && decoded.exp <= Date.now() / 1000